<template>
    <div class="row small-up-1 medium-up-2 large-up-3">
        <article v-for="storage_box in storage_boxes" class="column text-center c-card-box-wrapper">
            <a class="c-card-box">
                <div v-on:click.prevent="openProductPage(storage_box)" class="c-card-box-section">
                    <img v-if="storage_box.single_file" :src="changeImageSize(storage_box.single_file.media_path, 455, '600')" :alt="storage_box.single_file.media_title" class="c-card-box-image" alt="storage-box">
                    <header class="c-card-box-heading">
                        <span class="u-color-black">
                            {{ storage_box.name }} ({{ storage_box.formatted_min_size }}-{{ storage_box.formatted_max_size }}m³)
                        </span>
                        <p class="u-bold u-color-secondary">
                            {{ translate('frontend.js.storage_box.price', {'price' : storage_box.formatted_price}) }}
                        </p>
                    </header>
                    <div class="c-card-box-content">
                        {{ storage_box.description }}
                    </div>
                </div>
                <footer classs="c-card-box-footer">
                    <div class="flex-container flex-dir-column">
                        <button v-on:click.prevent="requestQuote(storage_box)" class="button is-red">{{ translate('frontend.js.storage_box.rent_now') }}</button>
                        <button v-on:click.prevent="openQuoteReveal(storage_box)" class="button u-no-margin-top">{{ translate('frontend.js.storage_box.request_quotation') }}</button>
                    </div>
                </footer>
            </a>
        </article>
        <quote-reveal
            v-if="toggle_quote_reveal"
            v-on:closeQuoteReveal="closeQuoteReveal"
            :storage_box="clicked_storage_box">
        </quote-reveal>
    </div>
</template>
<script>

    import QuoteReveal          from './quote-reveal';

    export default {
        name: 'storage-box',
        data() {
            return {
                storage_boxes: [],
                toggle_quote_reveal: false,
                clicked_storage_box: null,
            }
        },
        components: {
            'quote-reveal'      : QuoteReveal
        },
        mounted() {
            this.retrieveStorageBoxes();
        },
        methods: {
            /**
             * Get the storage boxes from the api
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            retrieveStorageBoxes() {
                axios.get('/api/storage-boxes')
                    .then(this.setStorageBoxes);
            },
            /**
             * Set the storage boxes and loading
             *
             * @author Rick van der Burg <rick@click.nl>
             * @param response
             */
            setStorageBoxes(response) {
                this.storage_boxes = response.data;
            },
            /**
             * Request the quotation
             *
             * @author Rick van der Burg <rick@click.nl>
             * @param  storage_box
             * @return void
             */
            requestQuote(storage_box) {
                // Measure Google Analytics Event before redirect to next page
                let box = storage_box.size_label.toUpperCase();

                // Check if gtag is set before tracking
                if( window.gtag ) {
                    gtag('event', 'begin_checkout', {
                        'event_category': 'ecommerce',
                        'event_label': 'Type box ' + box,
                        'transport_type': 'beacon',
                        'event_callback': function() {
                            window.location.href = '/box-huren/box-en-locatie?unit-type-group=' + box;
                        }
                    });
                } else {
                    window.location.href = '/box-huren/box-en-locatie?unit-type-group=' + box;
                }
            },

            /**
             * Opens the quote reveal
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @param  storage_box
             * @return void
             */
            openQuoteReveal(storage_box) {
                // Check if gtag is set before tracking
                if( window.gtag ) {
                    // Measure Google Analytics Event
                    gtag('event', 'generate_lead', {
                        'event_category': 'engagement',
                        'event_label': 'Open offerteformulier',
                        'transport_type': 'beacon'
                    });
                }

                this.clicked_storage_box = storage_box;
                this.toggle_quote_reveal = true;
            },

            /**
             * Close the quote reveal
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @return void
             */
            closeQuoteReveal() {
                this.toggle_quote_reveal = false;
            },

            /**
             * Redirect user to product page
             *
             * @author Robin van Leeuwen <robin@click.nl>
             * @param  storage_box
             */
            openProductPage(storage_box) {
                if(storage_box.translated_product_page_url != '') {
                    window.location.href = storage_box.translated_product_page_url;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/global/storage-box.vue